import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { Events, InfoBoxSeverity } from '../types';
import { ButtonColor } from '../../gzIconButton/types';

@customElement('gz-info-box')
export class GzInfoBoxWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  severity = InfoBoxSeverity.INFORMATIVE;

  @property({ type: Boolean, attribute: true, reflect: true })
  showDismissButton = false;

  @state()
  private readonly classIcon = new Map<InfoBoxSeverity, String>([
    [InfoBoxSeverity.SUCCESS, 'ds-icon-notification_success'],
    [InfoBoxSeverity.INFORMATIVE, 'ds-icon-notification_info'],
    [InfoBoxSeverity.WARNING, 'ds-icon-notification_warning'],
    [InfoBoxSeverity.ERROR, 'ds-icon-notification_negative'],
    [InfoBoxSeverity.UPDATE, 'ds-icon-whats_new'],
  ]);

  @state()
  private readonly iconColor = new Map<InfoBoxSeverity, ButtonColor>([
    [InfoBoxSeverity.SUCCESS, ButtonColor.SUCCESS],
    [InfoBoxSeverity.INFORMATIVE, ButtonColor.PRIMARY],
    [InfoBoxSeverity.WARNING, ButtonColor.WARNING],
    [InfoBoxSeverity.ERROR, ButtonColor.NEGATIVE],
    [InfoBoxSeverity.UPDATE, ButtonColor.WARNING],
  ]);

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="info-box-container ${this.severity}" part="container">
        <gz-icon
          class="icon"
          .name="${this.classIcon.get(this.severity)}"
          size="24"
          .color="${this.iconColor.get(this.severity)}"
        ></gz-icon>
        <div class="message">
          <slot></slot>
        </div>
        ${this.renderDismissButton()}
      </div>
    `;
  }

  updated() {
    this.dispatchEvent(
      new CustomEvent(Events.INFO_BOX_UPDATED, {
        detail: { infoBox: this },
        bubbles: true,
        composed: true,
      })
    );
  }

  private dismissHandler(): void {
    this.dispatchEvent(new CustomEvent(Events.DISMISSED));
    this.remove();
  }

  private renderDismissButton(): TemplateResult | undefined {
    if (!this.showDismissButton) {
      return;
    }
    return html`
      <div class="separator"></div>
      <gz-icon-button
        @click="${this.dismissHandler}"
        buttonColor="${ButtonColor.SECONDARY}"
        buttonFill="quiet"
        icon="ds-icon-clear"
        size="24"
        fontSize="18"
        class="dismiss-button"
      ></gz-icon-button>
    `;
  }
}
